<template>
  <article :id="documentId">
    <h2>{{title}} 全{{colorList.length}}色</h2>
    <template>
      <div class="colorPallet">
        <img :src="color.imgB" />
        <div class="color_list">
          <div class="left_arrow" @click="prevPage()">
            <div v-bind:class="{btn_left:true, noDisp: isColorPrev}"></div>
          </div>
          <div class="color_main">
            <ul class="wrap">
              <li v-for="(color,index) in colorList" :key="documentId + '-' + index" :value="color.id">
                <img :src="color.img" v-bind:class="{selected: hasSelectId(color.id)}" @click="$emit('selectColor', color)">
              </li>
            </ul>
          </div>
          <div class="right_arrow" @click="nextPage()">
            <div v-bind:class="{btn_right:true, noDisp: isColorNext}"></div>
          </div>
        </div>
      </div>
    </template>
    <div class="mini_title" v-if="colorList.length > 0">
      <div v-if="isSelectedColor">{{color.name}}</div>
      <div v-else>カラーが選択されていません。</div>
    </div>
  </article>
</template>
<script>
import * as App from '../../../../../utils/App'
const MAX_COLOR_VIEW_CNT = 10

export default {
  name: 'menu',
  components: {
  },
  props: {
    title: String,
    documentId: String,
    colorList: Array,
    color: Object
  },
  data () {
    return {
      page: 1
    }
  },
  methods: {
    prevPage: function () {
      if (this.page > 1) {
        this.page--
      }
    },
    nextPage: function () {
      if (this.page < this.maxPage) {
        this.page++
      }
    },
    // setBackgroundColor: function (nextColor) {
    //   document.getElementById(this.documentId).style.backgroundImage = 'url("' + nextColor.imgB + '")'
    // },
    hasSelectId: function (targetId) {
      if (!this.color) return false
      if (!Object.keys(this.color).length > 0) return false
      if (targetId !== this.color.id) return false
      return true
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  computed: {
    isColorPrev: function () {
      if (this.page <= 1) return true
      return false
    },
    isColorNext: function () {
      if (Number(this.page) === Number(this.maxPage)) return true
      return false
    },
    // viewColorList: function () {
    //   if (!this.colorList) return
    //   let startIdx = (this.page - 1) * MAX_COLOR_VIEW_CNT
    //   let endIdx = ((this.page) * MAX_COLOR_VIEW_CNT)
    //   return this.colorList.filter(function (element, index) {
    //     return (index >= startIdx && index < endIdx)
    //   })
    // },
    isSelectedColor: function () {
      if (!this.color) return
      if (!Object.keys(this.color).length > 0) return false
      return true
    },
    maxPage: function () {
      return Math.ceil(this.colorList.length / MAX_COLOR_VIEW_CNT)
    }
  },
  watch: {
    // color: function () {
    //   if (this.color) {
    //     this.setBackgroundColor(this.color)
    //   }
    // },
    colorList: function () {
      this.page = 1
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../../../../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-common.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/color/ColorPallet.vue